import { StepId, ComponentId } from "../constants";
import { removeFlowData } from "../actions";
export var expectedSavings = {
  id: StepId.BILLS_EXPECTED_SAVINGS,
  component: ComponentId.BILLS_EXPECTED_SAVINGS,
  isComplete: function isComplete(state, flowState) {
    return flowState.data.isExpectedSavingsStepComplete;
  },
  unComplete: function unComplete(dispatch, flowId) {
    return dispatch(removeFlowData(flowId, 'isExpectedSavingsStepComplete'));
  },
  route: 'billshark/expected-savings',
  webConfig: {
    hideHeader: true
  }
};
export var howItWorks = {
  id: StepId.BILLS_HOW_IT_WORKS,
  component: ComponentId.BILLS_HOW_IT_WORKS,
  isComplete: function isComplete(state, flowState) {
    return flowState.data.isHowItWorksStepComplete;
  },
  unComplete: function unComplete(dispatch, flowId) {
    return dispatch(removeFlowData(flowId, 'isHowItWorksStepComplete'));
  },
  route: 'billshark/how-it-works',
  webConfig: {
    hideHeader: true
  }
};
export var billInfo = {
  id: StepId.BILLS_BILL_INFO,
  component: ComponentId.BILLS_BILL_INFO,
  isComplete: function isComplete(state, flowState) {
    return flowState.data.createAccountSuccess;
  },
  route: 'billshark/bill-info',
  webConfig: {
    hideHeader: true
  }
};
export var confirmation = {
  id: StepId.BILLS_CONFIRMATION,
  component: ComponentId.BILLS_CONFIRMATION,
  isComplete: function isComplete(state, flowState) {
    return flowState.data.isConfirmationStepComplete;
  },
  route: 'billshark/confirmation',
  webConfig: {
    hideHeader: true
  }
};
export var billsSetupFlow = {
  steps: [expectedSavings, howItWorks, billInfo, confirmation]
};